exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".indiana-scroll-container {\n  overflow: auto;\n  width: 100%;\n  &\\--dragging {\n    > * {\n      pointer-events: none;\n      cursor: grab;\n    }\n  }\n  &\\--hide-scrollbars {\n    overflow: hidden;\n    overflow: -moz-scrollbars-none;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    &::-webkit-scrollbar {\n      display: none !important;\n      height: 0 !important;\n      width: 0 !important;\n      background: transparent !important;\n      -webkit-appearance: none !important;\n    }\n  }\n  &\\--native-scroll {\n    overflow: auto;\n  }\n}\n\n.indiana-dragging {\n  cursor: grab !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/IndianaScroll/style.css
// module id = ./node_modules/css-loader/index.js!./src/components/IndianaScroll/style.css
// module chunks = 0